/* eslint-disable node/no-process-env */

const scopeKey = "develop-ideaflow-id-cache-owner";
const legacyOwnerKey = "develop-ideaflow-id-legacy-cache-owner";

export function developCacheScope(): string | null {
  if (
    typeof window === "undefined" ||
    process.env.NEXT_PUBLIC_ENV !== "development" ||
    process.env.NEXT_PUBLIC_DEVELOP_IDEAFLOW_ID_ENABLED !== "true"
  )
    return null;
  return window.localStorage.getItem(scopeKey);
}

export function developCacheDatabaseName(): string {
  const owner = developCacheScope();
  return owner ? `IdeaflowDatabase-ideaflow-id-${encodeURIComponent(owner)}` : "IdeaflowDatabase";
}

/** Remember who owns the original database so a later account switch can return to it. */
export function rememberLegacyCacheOwner(owner: string): void {
  if (owner && !window.localStorage.getItem(legacyOwnerKey)) window.localStorage.setItem(legacyOwnerKey, owner);
}

/** Choose an isolated cache for another owner without deleting the previous owner's offline data. */
export function selectDevelopCacheOwner(owner: string): boolean {
  const scope = window.localStorage.getItem(legacyOwnerKey) === owner ? null : owner;
  if (developCacheScope() === scope) return false;
  if (scope) window.localStorage.setItem(scopeKey, scope);
  else window.localStorage.removeItem(scopeKey);
  return true;
}
